import { IXetKhoaLuanReducer } from "../../reducer-model/xet-khoa-luan/IXetKhoaLuanReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetKhoaLuanActionTypes } from "../../action-types/xet-khoa-luan/IXetKhoaLuanActions";

const iniState: IXetKhoaLuanReducer = {
    danhSachXets: {},
    focusedTab: "luan-van",
}

export const xetKhoaLuanReducer = (state: IXetKhoaLuanReducer = iniState, action: IXetKhoaLuanActionTypes): IXetKhoaLuanReducer => {
    switch (action.type) {
        case "XET_KHOA_LUAN_XET_START":
            return {
                ...state,
                isShowProcessing: true,
                processId: action.payload?.data?.process_id || undefined,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_loading,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
                
            };
        case "XET_KHOA_LUAN_XET_SUCCESS":
            // Clear dữ liệu các năm học, lần xét khác
            const newDanhSachXets = { ...state.danhSachXets };
            Object.keys(newDanhSachXets).forEach(key => {
                const [id_lops, nam_hoc, lan_xet] = key.split("_");
                if (id_lops === action.payload.request.id_lops.join(",") && (nam_hoc !== action.payload.request.nam_hoc || lan_xet !== action.payload.request.lan_xet.toString())) {
                    newDanhSachXets[key] = {
                        status: eReducerStatusBase.is_completed,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    };
                }
            });
            
            return {
                ...state,
                isShowProcessing: false,
                danhSachXets: {
                    ...newDanhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_need_reload,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_XET_ERROR":
            return {
                ...state,
                isShowProcessing: false,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_completed,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_SHOW_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: true,
            };
        case "XET_KHOA_LUAN_CLOSE_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: false,
            };
        case "XET_KHOA_LUAN_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false,
            };
        case "XET_KHOA_LUAN_FOCUSED_TAB_CHANGE":
            return {
                ...state,
                focusedTab: action.payload,
            };
        case "XET_KHOA_LUAN_INI_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.id_lops.join(",") + "_" + action.payload.nam_hoc + "_" + action.payload.lan_xet]: {
                        status: eReducerStatusBase.is_not_initialization,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_LOAD_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_loading,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_LOAD_SUCCESS":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_completed,
                        danhSachLuanVans: action.payload.data.danhSachLuanVans,
                        danhSachNoLuanVanThiTotNghieps: action.payload.data.danhSachNoLuanVanThiTotNghieps,
                        danhSachThiTotNghieps: action.payload.data.danhSachThiTotNghieps,
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_LOAD_ERROR":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        status: eReducerStatusBase.is_completed,
                        danhSachLuanVans: [],
                        danhSachNoLuanVanThiTotNghieps: [],
                        danhSachThiTotNghieps: [],
                        selectedIdsLuanVan: [],
                        selectedIdsThiTotNghiep: [],
                    }
                }
            };
        case "XET_KHOA_LUAN_CHANGER_SELECTED_IDS_LUAN_VAN":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        selectedIdsLuanVan: action.payload.data,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHANGER_SELECTED_IDS_THI_TOT_NGHIEP":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        selectedIdsThiTotNghiep: action.payload.data,
                    }
                }
            };
        case "XET_KHOA_LUAN_UPDATE_LOCK_STATUS_LUAN_VAN_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_loading,
                    }
                }
            };
        case "XET_KHOA_LUAN_UPDATE_LOCK_STATUS_LUAN_VAN_SUCCESS":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }
            };
        case "XET_KHOA_LUAN_UPDATE_LOCK_STATUS_LUAN_VAN_ERROR":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            };
        case "XET_KHOA_LUAN_UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_loading,
                    }
                }
            };
        case "XET_KHOA_LUAN_UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_SUCCESS":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_LUAN_VAN_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_loading,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_LUAN_VAN_SUCCESS":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_LUAN_VAN_ERROR":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_THI_TOT_NGHIEP_START":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_loading,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_THI_TOT_NGHIEP_SUCCESS":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }
            };
        case "XET_KHOA_LUAN_CHUYEN_THI_TOT_NGHIEP_ERROR":
            return {
                ...state,
                danhSachXets: {
                    ...state.danhSachXets,
                    [action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet]: {
                        ...state.danhSachXets[action.payload.request.id_lops.join(",") + "_" + action.payload.request.nam_hoc + "_" + action.payload.request.lan_xet],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            };
        default:
            return state;
    }
}